<md-dialog>
	<div md-dialog-header class="header">
		<md-icon md-border [icon]="{ type: 'url', icon: 'untitled-ui/time/clock-refresh' }"></md-icon>
		<div class="md-text-lg-semibold">Reschedule Lesson</div>
	</div>

	@if (rescheduling()) {
		<lb-loader message="Rescheduling your lesson"></lb-loader>
	} @else {
		<div class="reschedule-options">
			<!-- Option 1: After last scheduled lesson -->
			<div class="option" [class.disabled]="afterLastUnavailable()">
				<input type="radio" value="afterLastDate" md-form-input [formControl]="rescheduleOption" [attr.disabled]="afterLastUnavailable() ? '' : null" />
				<div class="option-info">
					<div class="option-title">Add after the last scheduled lesson</div>
					@if (rescheduleOption.value === 'afterLastDate') {
						<div class="option-description">
							@if (optionsLoading()) {
								<div class="after-last-loading">
									<lb-loader></lb-loader>
									<span>Computing next available date…</span>
								</div>
							} @else if (afterLastSessionDisplayDate(); as displayDate) {
								<div class="after-last-date">
									<md-icon icon="untitled-ui/general/calendar-check"></md-icon>
									<span>{{ displayDate | date: "EEEE, MMMM d 'at' h:mm a" }}</span>
								</div>
							} @else {
								<div class="after-last-unavailable">After last lesson date unavailable — please use "Enter new time" instead.</div>
							}
						</div>
					}
				</div>
			</div>

			<!-- Option 2: Enter new time -->
			<div class="option">
				<input type="radio" value="time" md-form-input [formControl]="rescheduleOption" />
				<div class="option-info">
					<div class="option-title">Enter new time</div>
					<div class="option-description">
						You’ve already confirmed a new lesson time with the learner. Updates the calendar with the rescheduled lesson for both you and the
						learner.

						@if (proposingNewDate()) {
							<div class="new-time-proposal">
								<div class="datetime-select">
									<lb-form-row>
										<lb-form-field>
											<label>Date</label>
											<input
												type="date"
												placeholder="YYYY-MM-DD"
												md-form-input
												md-date-picker-input
												[disabledDateFn]="disabledDates()"
												[formControl]="rescheduleDate"
											/>
										</lb-form-field>

										<lb-form-field>
											<label>Time</label>
											<md-drop-down [options]="timesOptions()" [formControl]="rescheduleTime"></md-drop-down>
										</lb-form-field>
									</lb-form-row>
								</div>

								<div class="check-status">
									@if (checking()) {
										<div class="check-checking">
											<lb-loader></lb-loader>
											<span class="md-text-xs-regular">Checking availability…</span>
										</div>
									} @else if (checkResult(); as result) {
										@if (result.isValid) {
											<div class="check-valid">
												<md-icon icon="untitled-ui/general/check-circle"></md-icon>
												<span class="md-text-xs-semibold">Time is available</span>
											</div>
										} @else {
											<div class="check-invalid">
												<md-icon icon="untitled-ui/general/alert-circle"></md-icon>
												<span class="md-text-xs-regular">{{ result.message }}</span>
											</div>
										}
									}
								</div>
							</div>
						}
					</div>
				</div>
			</div>

			<!-- Option 3: Let learner choose -->
			<div class="option">
				<input type="radio" value="learner" md-form-input [formControl]="rescheduleOption" />
				<div class="option-info">
					<div class="option-title">Reschedule later or let learner choose</div>
					<div class="option-description">Clears this lesson from the calendar and marks it for rescheduling by you or the learner.</div>
				</div>
			</div>
		</div>
	}

	<div md-dialog-footer>
		<button md-button [disabled]="rescheduling()" (click)="close()">Cancel</button>
		<button md-button-brand [disabled]="!canSubmit()" (click)="reschedule()">Update</button>
	</div>
</md-dialog>
